import { keys, filter, propEq } from 'ramda'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'
import formatContent from '@/utils/format-content'
import htmlToReact from '@/utils/html-to-react'

const DescriptionWrapper = styled.div`
  word-break: break-word;
  white-space: pre-line;
  max-width: 640px;
  width: 100%;

  div {
    width: unset !important;
  }
`

const AddendumDescription = ({ addendum, variables }) => {
  const { t } = useTranslation()

  if (addendum.data_type === 'content') {
    return (
      <DescriptionWrapper>
        {htmlToReact(formatContent(addendum.content, variables), true)}
      </DescriptionWrapper>
    )
  }

  const allowedOptions = keys(filter(propEq('selected', true))(addendum.metadata?.options || {}))

  return (
    <DescriptionWrapper>
      {addendum.metadata?.allowed ? (
        <>
          <p>Smoking is allowed only in designated areas including:</p>
          <ul>
            {allowedOptions.map(option => (
              <li key={option}>{`${t(
                `l.contract.edit.addendum_modal_smoking_${option}.label`
              )}`}</li>
            ))}
          </ul>
          <p>Anywhere else in the building is strictly prohibited under Strata Bylaw S2.3</p>
        </>
      ) : (
        <div>
          <p>
            We would like to clarify that as per your tenancy agreement, your suite is designated
            &quot;non-smoking&quot;. This also applies to the use of cannabis, e-cigarettes (vaping)
            and similar devices. Smoking is prohibited inclusive of balconies (limited common area).
            This is a mandatory term for your tenancy. Please note that a breach of a mandatory term
            will result in a notice to end tenancy.
          </p>
          <p>
            Growing marijuana/cannabis is not permitted in the unit, especially due to humidity,
            mold and odor issues. Please note: growing marijuana plants is also not permitted on
            limited common areas such as patios and balconies.
          </p>
          <ul>
            <li>In Unit</li>
            <li>Balcony</li>
            <li>Designated Area</li>
          </ul>
        </div>
      )}
    </DescriptionWrapper>
  )
}

export default AddendumDescription
